import { ShoppingCartOutlined } from "@ant-design/icons";
import { Image, Modal, Table } from "antd";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import * as cookingProgressJson from "../animations/cooking.json";
import * as cookingReadyJson from "../animations/green-check.json";
import * as cookingCreatedJson from "../animations/progress.json";
import { useGetRestaurantTableItemStatuses } from "../api/api.get";
import { PlainLottie } from "../components/lottie.viewer.component";
import { EXHUT_BIZ_SCAN_TO_ORDER_TABLE_CODE } from "../utils/constants";
import { capitalize, capitalizeFirst } from "../utils/functions";

export default function OrderStatus({
  open,
  onCancel,
  tableName,
}: {
  tableName?: string;
  open: boolean;
  onCancel: () => void;
}) {
  const { id } = useParams();
  const tableCode = localStorage.getItem(EXHUT_BIZ_SCAN_TO_ORDER_TABLE_CODE);

  const {
    data: kitchenItemStatuses,
    refetch,
    isLoading,
  } = useGetRestaurantTableItemStatuses(id, tableCode!);

  useEffect(() => {
    if (open) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const columns = [
    {
      key: "1",
      title: "Item",
      dataIndex: "productName",
      render: (value: string) => <strong>{capitalize(value)}</strong>,
    },
    {
      key: "2",
      title: "Status",
      dataIndex: "status",
      render: (status: string) => (
        <div>
          {status === "UNKNOWN" && (
            <Image
              src={"/assets/icons/clock.png"}
              style={{ width: 20, height: 20 }}
            />
          )}
          {status === "CREATED" && (
            <PlainLottie animationData={cookingCreatedJson} size={30} />
          )}
          {status === "PROGRESS" && (
            <PlainLottie animationData={cookingProgressJson} />
          )}
          {status === "READY" && (
            <PlainLottie animationData={cookingReadyJson} />
          )}
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={capitalizeFirst(tableName) ?? "-"}
      open={open}
      onCancel={onCancel}
      okText="Send"
      footer={null}
    >
      {!isLoading &&
      (!kitchenItemStatuses || kitchenItemStatuses.length === 0) ? (
        <div className="flex flex-col items-center justify-center gap-2 py-10 text-center text-gray-500">
          <ShoppingCartOutlined style={{ fontSize: 32 }} />
          <p>No items found in your order.</p>
        </div>
      ) : (
        <Table
          dataSource={kitchenItemStatuses}
          columns={columns}
          pagination={false}
        />
      )}
    </Modal>
  );
}
